import { AssetImportance } from '@rtkwlf/mr-infra-risk';

import type { GridSingleSelectColDef } from '@packages/fenrir/components/datagrid';
import {
  getFilteredGridSelectOperators,
  GridSelectOperator,
} from '@packages/fenrir/components/datagrid';

import { AssetCriticalityCell } from '../cell/asset-criticality-cell/asset-criticality-cell';
import { translateOptions } from '../translate-options/translate-options';

const assetImportanceOptions = translateOptions(
  Object.values(AssetImportance).reverse(),
  'riskManagement:risks.assetImportance',
);

export const assetCriticalityColumnType: Omit<GridSingleSelectColDef, 'field'> =
  {
    display: 'flex',
    flex: 0.2,
    minWidth: 115,
    type: 'singleSelect',
    filterOperators: getFilteredGridSelectOperators([
      GridSelectOperator.isAnyOf,
    ]),
    valueOptions: assetImportanceOptions,
    renderCell: (params) => <AssetCriticalityCell {...params} />,
  };
